function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgFocusedBackToTopButton = function SvgFocusedBackToTopButton(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.779,
    height: 78,
    viewBox: "0 0 186.779 78"
  }, props), h("defs", null, h("filter", {
    id: "a",
    width: 78,
    height: 78,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, h("feOffset", null), h("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), h("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.302
  }), h("feComposite", {
    in2: "blur",
    operator: "in"
  }), h("feComposite", {
    in: "SourceGraphic"
  }))), h("g", {
    "data-name": "Back-To-Top (FocusIn)"
  }, h("g", {
    "data-name": "FocusIn Label"
  }, h("path", {
    fill: "rgba(255,255,255,0.15)",
    fillRule: "evenodd",
    d: "M184.769 22.25H81.087a2.01 2.01 0 0 0-2.01 2.01v9.332L73 39l6.077 5.408v9.335a2.01 2.01 0 0 0 2.01 2.01h103.682a2.01 2.01 0 0 0 2.01-2.01v-29.48a2.01 2.01 0 0 0-2.01-2.013",
    "data-name": "Path 85"
  }), h("text", {
    fill: "#fff",
    "data-name": "Back To Top",
    fontFamily: "Barlow-Medium, Barlow",
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: "-.005em",
    transform: "translate(133 44.25)"
  }, h("tspan", {
    x: -41.52,
    y: 0
  }, "Back To Top"))), h("g", {
    filter: "url(#a)"
  }, h("path", {
    fill: "#fff",
    d: "M39 15a24 24 0 1 1-24 24 24 24 0 0 1 24-24",
    "data-name": "FocusIn Border"
  })), h("path", {
    fillRule: "evenodd",
    d: "M40.087 46.985V33.673l3.989 4.265a1.13 1.13 0 0 0 1.619.039 1.087 1.087 0 0 0 .039-1.58l-5.964-6.359-.039-.039-.039-.039-.118-.115-.039-.039c-.039-.039-.079-.039-.118-.079-.039 0-.039 0-.079-.039-.039 0-.079-.039-.118-.039h-.395c-.039 0-.079.039-.118.039s-.039 0-.079.039-.079.039-.118.079l-.039.039-.118.118-.039.039-.039.039-5.964 6.4a1.12 1.12 0 0 0 .039 1.58 1.21 1.21 0 0 0 1.619-.039l3.831-4.3v13.303a1.146 1.146 0 0 0 2.291 0Z",
    "data-name": "Path 83"
  })));
};
export default SvgFocusedBackToTopButton;